import React, { useEffect, useState } from "react";
import "./TableBookings.css";
import Modal from "./Modal"; // Make sure you have this component

export default function TableBookings({ setIsAnyModalActive }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalConfig, setModalConfig] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  // Fetch bookings from backend
  const fetchBookings = async (showSpinner = false) => {
    if (showSpinner) setLoading(true);

    try {
      const res = await fetch("https://admin.deedelicious.com/php/get-table-bookings.php");
      const data = await res.json();

      // Sort bookings by ID
      setBookings(data.bookings.sort((a, b) => a.id - b.id));
    } catch (err) {
      console.error("Error fetching bookings:", err);
    } finally {
      if (showSpinner) setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(true);
    const interval = setInterval(() => fetchBookings(false), 5000);
    return () => clearInterval(interval);
  }, []);

  // Delete booking
  const deleteBooking = async (id) => {
    setActionLoading(true);
    setModalConfig(null);
    if (setIsAnyModalActive) setIsAnyModalActive(false);

    try {
      const res = await fetch("https://admin.deedelicious.com/php/delete-table-booking.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        fetchBookings(false);
      }
    } catch (err) {
      console.error("Server error:", err);
    } finally {
      setActionLoading(false);
    }
  };

  // Open delete confirmation modal
  const openDeleteModal = (booking) => {
    setModalConfig({
      title: "Delete Booking",
      content: (
        <div className="delete-modal-heading">
          <p>
            Are you sure you want to delete the booking for{" "}
            <strong>{booking.first_name} {booking.last_name}</strong>?
          </p>
        </div>
      ),
      onConfirm: () => deleteBooking(booking.id),
      type: "CONFIRM_MODAL",
    });
    if (setIsAnyModalActive) setIsAnyModalActive(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const closeModal = () => {
    setModalConfig(null);
    if (setIsAnyModalActive) setIsAnyModalActive(false);
  };

  return (
    <div className="dd-admin-wrapper">
      <h2>Table Bookings</h2>

      {(loading || actionLoading) && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {!loading && (
        <table className="dd-table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Seats</th>
              <th>Date</th>
              <th>Time</th>
              <th>Special Request</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {bookings.length === 0 ? (
              <tr>
                <td colSpan="9" className="dd-no-data">
                  No bookings found.
                </td>
              </tr>
            ) : (
              bookings.map((b, index) => (
                <tr key={b.id}>
                  <td>{index + 1}</td>
                  <td>{b.first_name}</td>
                  <td>{b.last_name}</td>
                  <td>{b.phone}</td>
                  <td>{b.email}</td>
                  <td>{b.seats}</td>
                  <td>{b.booking_date}</td>
                  <td>{b.booking_time}</td>
                  <td>{b.special_request || "None"}</td>
                  <td className="dd-action-column">
                    <button
                      className="dd-delete-btn"
                      onClick={() => openDeleteModal(b)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {/* Delete Confirmation Modal */}
      {modalConfig && (
        <Modal
          title={modalConfig.title}
          onClose={closeModal}
          showCancel={true}
          showSubmitButton={true}
          submitButtonText={actionLoading ? "Deleting..." : "Delete"}
          onSubmit={async (e) => {
            e.preventDefault();
            if (modalConfig.onConfirm) await modalConfig.onConfirm();
          }}
        >
          {modalConfig.content}
        </Modal>
      )}
    </div>
  );
}
